import store from '@/state/store'
const fields = [
  {
    key: 'licensePlate',
    label: 'report.fields.licensePlate',
    header: 'licensePlate',
    filter: true,
    width: 20,
  },
  {
    key: 'driverName',
    label: 'report.fields.driver',
    header: 'driver',
    filter: true,
    width: 20,
  },
  {
    key: 'fenceName',
    label: 'report.report.geofence',
    header: 'fenceName',
    filter: true,
    width: 10,
  },
  {
    key: 'geolocationIn',
    label: 'report.fields.timeInGeo',
    header: 'geolocationIn',
    filter: true,
    width: 20,
  },
  {
    key: 'geolocationOut',
    label: 'report.fields.timeOutGeo',
    header: 'geolocationOut',
    filter: true,
    width: 20,
  },
  {
    key: 'totalDurationFormatted',
    label: 'report.fields.durationInGeo',
    header: 'totalDurationFormatted',
    filter: true,
    width: 20,
  },
]
if (store.getters['identity/hasAccess'](['report_imei_column:read'])) {
  fields.splice(1, 0, {
    key: 'imei',
    label: 'report.fields.imei',
    header: 'imei',
    filter: true,
    width: 20,
  })
}
export default fields
